import React from "react";
import { Link } from "react-router-dom";
import { renderCustomColumnDefs } from "../../../shared/Table/table.utils";
import StatusPill from "./StatusPill";

/**
 * Format a Date or ISO string as MM/DD/YYYY in the local zone.
 * Returns an em-dash for falsy values so the table never shows
 * "Invalid Date".
 */
const formatShortDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString();
};

/**
 * Format the populated assignedTo user object into a display name,
 * falling back to email or the literal "Unassigned".
 */
const formatAssignee = (assignedTo) => {
  if (!assignedTo) return "Unassigned";
  const first = assignedTo.firstName || "";
  const last = assignedTo.lastName || "";
  const name = `${first} ${last}`.trim();
  return name || assignedTo.email || "Unassigned";
};

/**
 * Column config for the Super Admin Leads inbox table. Mirrors the
 * pattern used by SuperAdmin/Customers (renderCustomColumnDefs +
 * sentinel pageSizeOptions). Status renders as a colored pill via the
 * shared <StatusPill> component.
 */
const tableConfig = [
  {
    id: "dateCreated",
    Header: "Created",
    cell: ({ row: { original } }) => formatShortDate(original.dateCreated),
  },
  {
    id: "companyName",
    Header: "Company",
    cell: ({ row: { original }, getValue }) => (
      <Link
        className="text-primary-600 hover:underline"
        to={`/admin/leads/${original._id}`}
      >
        {getValue() || "—"}
      </Link>
    ),
  },
  {
    id: "contactName",
    Header: "Contact",
    cell: ({ getValue }) => getValue() || "—",
  },
  {
    id: "email",
    Header: "Email",
    cell: ({ getValue }) => getValue() || "—",
  },
  {
    id: "phone",
    Header: "Phone",
    cell: ({ getValue }) => getValue() || "—",
  },
  {
    id: "status",
    Header: "Status",
    cell: ({ getValue }) => <StatusPill status={getValue()} />,
  },
  {
    id: "assignedTo",
    Header: "Assigned To",
    cell: ({ row: { original } }) => formatAssignee(original.assignedTo),
  },
  {
    id: "type",
    Header: "Type",
    cell: ({ getValue }) => getValue() || "contact_form",
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);

export const PAGE_SIZE_OPTIONS = [
  { label: "25 Leads", value: 25 },
  { label: "50 Leads", value: 50 },
  { label: "100 Leads", value: 100 },
];

export const STATUS_FILTER_OPTIONS = [
  { label: "All statuses", value: "" },
  { label: "New", value: "new" },
  { label: "Contacted", value: "contacted" },
  { label: "Qualified", value: "qualified" },
  { label: "Demo scheduled", value: "demo_scheduled" },
  { label: "Won", value: "won" },
  { label: "Lost", value: "lost" },
];
